
import { Component, Prop, Mixins } from 'vue-property-decorator'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import { isAppUsing } from 'bits/flip'

@Component({ components: { OzIcon, OzTextButton } })
export default class SurfacePostAttachmentEmbedControl extends Mixins() {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() isDownloadable!: boolean
  @Prop() downloadUrl!: string
  @Prop() dir!: string

  get isDarkColorScheme(): boolean {
    return this.colorScheme === 'dark'
  }

  get isExpandingPost(): boolean {
    return isAppUsing('expandedPostV1')
  }
}
